module.exports = __webpack_public_path__ + "static/media/favorites.6ac8acc9.svg";